<template>
  <div class="main-wrapper">
    <!---Sidebar-->
    <SideBar :logo="require('@/assets/images/logo/beregsz_logo.png')" parent=".main-wrapper"/>
    <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar">
      <vs-row>
        <div  class="menuIcon">
          <vs-icon icon="menu" size="30px"></vs-icon>
        </div>
      </vs-row>
    </div>
    <!---Page Container-->
    <div class="main-container-fluid">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>

import SideBar from '@/layout/full/sidebar/SideBar.vue';

export default {
  name: "MainContainer",
  components: {
    SideBar

  },
  data: () => ({}),
  methods: {
    activeSidebar() {
      this.$store.commit('IS_SIDEBAR_ACTIVE', true);
    },
  }
}
</script>

<style>

.con-vs-card {
  background-color: rgba(249, 240, 223, 0.95);
}

.vs-con-table {
  background: transparent;
}

.vs-table--thead tr {
  background-color: #444;
  color: #FFF;
}

.vs-con-table.stripe .tr-values {
  background-color: rgba(255, 255, 255, 0.45);
}

.vs-con-table.stripe .tr-values:nth-child(2n) {
  background-color: rgba(255, 255, 255, 0.85) !important;
}

.menuIcon {
  background-color: #333;
  color: white;
  border-radius: 5px 0 0 5px;
  width: 40px;
  height: 35px;
  padding-top: 2px;
  paddin-left: 1px;
  right: 0;
  top:15px;
  position:absolute;
  text-align: center;
}
</style>